export interface SearchOption {
  value: string;
  label: string;
}

export const CANONICAL_CATEGORIES: SearchOption[] = [
  { value: 'Micro', label: 'Micro' },
  { value: 'Mini', label: 'Mini' },
  { value: 'Junior', label: 'Junior' },
  { value: 'Max', label: 'Max' },
  { value: 'Master', label: 'Master' },
  { value: 'DD2', label: 'DD2' },
  { value: 'DD2 Master', label: 'DD2 Master' },
  { value: 'Club', label: 'Club' },
];

export const CANONICAL_TRACKS: SearchOption[] = [
  { value: 'Wohlen', label: 'Wohlen' },
  { value: 'Franciacorta', label: 'Franciacorta' },
  { value: 'Lonato', label: 'Lonato' },
  { value: 'Castelletto', label: 'Castelletto' },
  { value: 'Mirecourt', label: 'Mirecourt' },
  { value: '7 Laghi', label: '7 Laghi' },
  { value: 'Vesoul', label: 'Vesoul' },
  { value: 'Lévier', label: 'Lévier' },
  { value: 'Bopfingen', label: 'Bopfingen' },
];

export const CANONICAL_CHAMPIONSHIPS: SearchOption[] = [
  { value: 'RMC', label: 'RMC Switzerland' },
  { value: 'Swiss Championship', label: 'Swiss Championship' },
  { value: 'Club Championship', label: 'Club Championship' },
];

export const CANONICAL_SESSION_TYPES: SearchOption[] = [
  { value: 'race', label: 'filter.sessionType.race' },
  { value: 'final', label: 'filter.sessionType.final' },
  { value: 'pre_final', label: 'filter.sessionType.pre_final' },
  { value: 'heat', label: 'filter.sessionType.heat' },
  { value: 'qualifying', label: 'filter.sessionType.qualifying' },
];

